module.exports = __webpack_public_path__ + "static/loading-edcb3e913482c657ab6c206d154df7be.png";